// Mirrors the runtime source of truth in process-jobs: src/services/erinJobShape.ts.
// These ERIN job fields are supplied automatically by the transform's fixed alias + allowlist
// passthrough, so a JobSyncConfig does NOT need to map them — operators only add mappings for
// fields that need reshaping (department.*, location.*) or rule-set/bonus logic.
//
// Keep in sync with process-jobs/src/services/erinJobShape.ts (PASSTHROUGH_FIELDS / ALIAS).
export const AUTO_PASSTHROUGH_FIELDS = ['externalJobId', 'title', 'description', 'publicLink', 'hiringManagerEmail'];

// The fixed normalized-source → ERIN aliases that feed the passthrough (for operator reference).
export const PASSTHROUGH_ALIASES = {
	atsJobId: 'externalJobId',
	applyUrl: 'publicLink',
	recruiterEmail: 'hiringManagerEmail',
};
